import LedgerDetails from "../../pages/dashboard/ledger/LedgerDetails";
import LedgerIndex from "../../pages/dashboard/ledger/LedgerIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const ledger_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_LEDGER,
    element: LedgerIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_LEDGER_DETAILS,
    element: LedgerDetails,
  },
];
